export default [
    {
        path: 'unidade-externa',
        component: () => import(
            /* webpackChunkName: 'cadastro-unidade-externa' */
            '@/views/cadastro/unidade-externa/Index'
        ),
        redirect: 'unidade-externa/index',
        children: [
            {
                name: 'cadastro-unidade-externa-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'cadastro-unidade-externa' */
                    '@/views/cadastro/unidade-externa/List.vue'
                ),
            },
            {
                name: 'cadastro-unidade-externa-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'cadastro-unidade-externa' */
                    '@/views/cadastro/unidade-externa/Form.vue'
                ),
            },
            {
                name: 'cadastro-unidade-externa-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'cadastro-unidade-externa' */
                    '@/views/cadastro/unidade-externa/Form.vue'
                ),
            },
        ],
    },
]